import "react";
import { j as s } from "./jsx-runtime-3tyXYecC.mjs";
import { a as l, p as a, T as u } from "./tss-DN0acMKN.mjs";
import { G as f } from "./emotion-react.browser.esm-BdEGsKDn.mjs";
import { e as i } from "./extendSxProp-BhQEuuTD.mjs";
function p(t) {
  return t == null || Object.keys(t).length === 0;
}
function c(t) {
  const {
    styles: e,
    defaultTheme: o = {}
  } = t, n = typeof e == "function" ? (r) => e(p(r) ? o : r) : e;
  return /* @__PURE__ */ s.jsx(f, {
    styles: n
  });
}
function m({
  styles: t,
  themeId: e,
  defaultTheme: o = {}
}) {
  const n = l(o), r = typeof t == "function" ? t(e && n[e] || n) : t;
  return /* @__PURE__ */ s.jsx(c, {
    styles: r
  });
}
function x(t) {
  return /* @__PURE__ */ s.jsx(m, {
    ...t,
    defaultTheme: a,
    themeId: u
  });
}
function T(t) {
  return function(o) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ s.jsx(x, {
        styles: typeof t == "function" ? (n) => t({
          theme: n,
          ...o
        }) : t
      })
    );
  };
}
function g() {
  return i;
}
export {
  c as G,
  T as g,
  g as i
};
//# sourceMappingURL=index-BFVfkEeQ.mjs.map
